import React, {Component} from 'react'
import {FormattedMessage, FormattedNumber} from 'react-intl'
import Icon from "../../../common/icon/icon.component.jsx";
import UAParser from "ua-parser-js";

class QuoteProposedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            quote: this.props.quote || null,
            invoice: this.props.invoice || null,
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            quote: nextProps.quote || null,
            invoice: nextProps.invoice || null,
            proposal: nextProps.proposal || null,
        })
    }

    renderSeconds(seconds) {
        if (seconds < 60) {
            return seconds + ' sec'
        } else {
            let sec = ''
            const secondsLeft = seconds - (Math.floor(seconds/60) * 60)
            if (secondsLeft > 0) {
                sec =  secondsLeft + ' sec'
            }
            return Math.floor(seconds/60) + ' min ' + sec
        }
    }

    render() {
        const parser = new UAParser()
        parser.setUA(this.state.object.attributes.userAgent)
        const userAgent = parser.getResult()
        const obj = this.state.invoice || this.state.quote

        return <div className={"row " + this.state.className}>
            <div className="col-12">
                <p className={'mb-0'}>
                    {this.state.proposal.attributes.variables.document.type === 'invoice' ? <FormattedMessage
                        id="quote.analytics.events.invoice_view.text"
                        defaultMessage="Invoice {identifier} has been viewed"
                        values={{
                            identifier: <strong>{obj.attributes.identifier}</strong>,
                        }}
                    /> : <FormattedMessage
                        id="quote.analytics.events.proposal_view.text"
                        defaultMessage="Proposal {identifier} has been viewed"
                        values={{
                            identifier: <strong>{obj.attributes.identifier}</strong>,
                        }}
                    />}
                </p>
            </div>
            <div className={'col-12 d-flex align-items-center flex-wrap'}>
                <div className={'mr-5'}>
                    <h3 className={"m-0"}>
                        {['iOS', 'Android'].includes(userAgent.os.name) ? <Icon value={"mobile-alt"}/> : <Icon value={"desktop"}/>}
                    </h3>
                </div>
                <div className={'mr-5'}>
                    <div className={'w-100'}>
                        <label className="col-form-label custom-form-label">
                            <strong>
                                <FormattedMessage
                                    id="quote.analytics.events.proposal_view.total_time_spent"
                                    defaultMessage="Total time spent"
                                />
                            </strong>
                        </label>
                    </div>
                    <h4 className={"m-0"}>
                        {this.renderSeconds(this.state.object.attributes.duration)}
                    </h4>
                </div>
                <div>
                    <div className={'w-100'}>
                        <label className="col-form-label custom-form-label">
                            <strong>
                                <FormattedMessage
                                    id="quote.analytics.events.proposal_view.total_time_spent_on_pricing"
                                    defaultMessage="Total time spent on pricing table"
                                />
                            </strong>
                        </label>
                    </div>
                    <h4 className={"m-0"}>
                        {this.renderSeconds(this.state.object.attributes.durationOnPricingTable)}
                        &nbsp;
                        (<FormattedNumber
                            style="percent"
                            value={this.state.object.attributes.durationOnPricingTable/this.state.object.attributes.duration}
                        />)
                    </h4>
                </div>

            </div>
        </div>
    }

}

export default QuoteProposedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/proposal-view.component.jsx